"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/jsx-key */
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var TableHeaderCell_1 = require("../../atoms/TableHeaderCell");
var Checkbox_1 = require("../../atoms/Checkbox");
var styles_1 = __importDefault(require("./styles"));
/**
 * @deprecated
 */
exports.TableHeader = react_1.default.memo(function (_a) {
    var tableHeaderCells = _a.tableHeaderCells, checkboxes = _a.checkboxes, headerGroups = _a.headerGroups, rest = __rest(_a, ["tableHeaderCells", "checkboxes", "headerGroups"]);
    var classes = (0, styles_1.default)();
    return ((0, jsx_runtime_1.jsx)(core_1.TableHead, __assign({ "data-testid": "general-table-header", role: "columnheader", className: classes.header }, { children: headerGroups.map(function (headerGroup) { return ((0, jsx_runtime_1.jsxs)(core_1.TableRow, __assign({ "data-testid": "table-header-row" }, { children: [checkboxes && ((0, jsx_runtime_1.jsx)(TableHeaderCell_1.TableHeaderCell, __assign({ defaultSortOrder: "asc", role: "checkbox" }, { children: (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, __assign({ id: "id" }, rest)) }))), headerGroup.headers.map(function (column, index) { return ((0, jsx_runtime_1.jsx)(TableHeaderCell_1.TableHeaderCell, __assign({}, column.getHeaderProps(), tableHeaderCells[index], { role: "cell" }, { children: column.render('Header') }))); })] }))); }) })));
});
